import { Pipe, PipeTransform } from '@angular/core';
import { formatPhone } from '../functions';

@Pipe({
  name: 'phone',
})
export class PhonePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatPhone(value);
  }
}
